import React from "react";
import ReactApexChart from "react-apexcharts";
import { lineChartData, lineChartOptions } from "variables/charts";

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    // Ensure chart data is properly formatted
    try {
      this.setState({
        chartData: lineChartData || [],
        chartOptions: lineChartOptions || {},
      });
    } catch (error) {
      console.warn('Error setting chart data:', error);
      this.setState({
        chartData: [],
        chartOptions: {},
      });
    }
  }

  render() {
    // Safety check to prevent ApexCharts errors
    if (!this.state.chartData || !this.state.chartOptions || 
        !Array.isArray(this.state.chartData) || this.state.chartData.length === 0) {
      return <div>Loading chart...</div>;
    }

    return (
      <ReactApexChart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="area"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;
